/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable react/jsx-filename-extension */
import { ClusterOutlined } from '@ant-design/icons';
import * as SaldosMasivos from 'views/ProcesosMasivos/SaldosMasivos';
import * as DescuentosMasivos from 'views/ProcesosMasivos/DescuentosMasivos';

export default {
  title: 'Procesos Masivos',
  icon: () => <ClusterOutlined />,
  showInSidebar: true,
  type: 'private',
  children: [
    {
      title: 'Saldos Masivos',
      icon: null,
      showInSidebar: true,
      type: 'private',
      component: SaldosMasivos.default,
      permissionConfig: SaldosMasivos.permissionConfig,
    },
    {
      title: 'Descuentos Masivos',
      icon: null,
      showInSidebar: true,
      type: 'private',
      component: DescuentosMasivos.default,
      permissionConfig: DescuentosMasivos.permissionConfig,
    },
  ],
};
